export const getFirstMatchingSecurityByRef = ({ cellColumnRef, securities = [] }) =>
  securities.find(security => security.reference === cellColumnRef) || {};

export const isUnderlyingSecurity = ({ cell, warrantSecurity, matchingAlias }) =>
  cell.securityRef === warrantSecurity.underlying_security_ref || cell.alias === matchingAlias;
